import { render, staticRenderFns } from "./commonTakePhoto.vue?vue&type=template&id=13326e8c&scoped=true&"
import script from "./commonTakePhoto.vue?vue&type=script&lang=js&"
export * from "./commonTakePhoto.vue?vue&type=script&lang=js&"
import style0 from "./commonTakePhoto.vue?vue&type=style&index=0&id=13326e8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13326e8c",
  null
  
)

export default component.exports